import { render, staticRenderFns } from "./custom-form-Ex.vue?vue&type=template&id=2e46e635&scoped=true&"
import script from "./custom-form-Ex.vue?vue&type=script&lang=js&"
export * from "./custom-form-Ex.vue?vue&type=script&lang=js&"
import style0 from "./custom-form-Ex.vue?vue&type=style&index=0&id=2e46e635&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e46e635",
  null
  
)

export default component.exports